import { Grid as GridMantine } from '@mantine/core'
import styled from 'styled-components'

export const Grid = styled(GridMantine)`
  gap: ${({ gap }) => gap};
  .mantine-Grid-root {
    display: none;
  }
`
